import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from '../../imCustomRuleActionsForm';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../../webcomponents.constants';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import {
  getIntegrityMonitorRulesRegistryValueAttributes,
  IntegrityMonitorPlatform,
} from '../../../../common/utils/types';
import { GzHardCodedFormField } from '../../../../../ui/gzForm/formField/component/GzHardCodedFormField';
import { CustomRuleValidators } from '../../common/validators';
import { IMConstants } from '../../../../common/utils/IMConstants';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { IntegrityMonitorInputWithChipsWebComponent } from '../../imCustomRuleInputWithChips/IntegrityMonitorCustomRuleInputWithChipsWebComponent';

export class IntegrityMonitorRegistryValueRuleFormView extends BaseWebComponentView {
  public formGroup: FormGroup;

  public dom: {
    $securitySubtitle: GzTitleWebComponent;

    $valueFormField: GzFormFieldWebComponent<IntegrityMonitorInputWithChipsWebComponent, string[]>;

    $actionsForm: IntegrityMonitorCustomRuleActionsFormWebComponent;
  };

  getDomElements() {
    this.dom = {
      $securitySubtitle: this.shadow.querySelector('#security-subtitle'),

      $valueFormField: this.shadow.querySelector('#value-form-field'),

      $actionsForm: this.shadow.querySelector(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM),
    };

    this.getTranslations();
    this.setTranslatedStrings();
    this.createFormGroup();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
  }

  setTranslatedStrings() {
    this.dom.$securitySubtitle.innerText = this.translations.securitySubtitle;

    this.dom.$valueFormField.label = this.translations.entityTypeRegistryValue.valueLabel;
    this.dom.$valueFormField.Input.placeholder = this.translations.entityTypeRegistryValue.valuePlaceholder;
  }

  createFormGroup() {
    this.dom.$valueFormField.Validators = [
      CustomRuleValidators.atLeastOneValidator(this.translations.entityTypeRegistryValue.errorAtLeastOneValue),
      CustomRuleValidators.atMostValidator(
        IMConstants.INTEGRITY_MONITOR_RULE_REGISTRYVALUE_MAX_ALLOWED_VALUES,
        this.translations.entityTypeRegistryValue.errorTooManyValues
      ),
    ];

    this.dom.$valueFormField.Input.maxValues = IMConstants.INTEGRITY_MONITOR_RULE_REGISTRYVALUE_MAX_ALLOWED_VALUES;

    this.dom.$valueFormField.Input.validator = CustomRuleValidators.registryValueValidator(
      this.translations.validationErrors
    );

    this.dom.$valueFormField.Input.translations = this.translations.validationErrors;

    this.dom.$valueFormField.initialValue = [];

    this.formGroup = FormGroup.build({
      os: new GzHardCodedFormField<number>(IntegrityMonitorPlatform.WINDOWS),
      registryValues: this.dom.$valueFormField,
    });
  }

  buildSuccessView(data: any) {
    this.dom.$actionsForm.injectDependencies(this.dependencies);
    this.dom.$actionsForm
      .start()
      .catch(console.warn)
      .then(() => {
        this.dom.$actionsForm.options = getIntegrityMonitorRulesRegistryValueAttributes(this.dependencies.translateFn);
        this.formGroup.addFormChild(['attributes'], this.dom.$actionsForm.controller.view.formGroup);
      });
  }
}
